module.exports = __webpack_public_path__ + "img/225708b.png";